/**
 * tolling-api v2
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export interface ActivityDistanceResponseDto {
    value: number;
    unit: ActivityDistanceResponseDto.UnitEnum;
}
export namespace ActivityDistanceResponseDto {
    export const UnitEnum = {
        Km: 'KM',
        Mi: 'MI',
    } as const;
    export type UnitEnum = (typeof UnitEnum)[keyof typeof UnitEnum];
}
